<template>
	<div>
		<div style="padding: 10px;font-weight: bold;font-size: 18px;">页脚设置</div>
		<div style="height:  1px;background-color: #c7c7c7;margin: auto;margin: 6px;"></div>
		<div style="padding: 10px;display: flex;">
			<div style="font-size: 14px;">页脚宽度设置</div>
			<div style="margin-left: 10px;">
				<div style="display: flex;align-items: center;font-size: 12px;cursor: pointer;">
					<div @click="selectType(dataItem.bg.setWidth,'percentage')"
						:style="{backgroundColor: dataItem.bg.setWidth.type == 'percentage'?'#605bf6':'#fff',color: dataItem.bg.setWidth.type == 'percentage'?'#fff':'#000'}"
						style="width: 120px;border-radius: 6px 0px 0px 6px;padding: 4px;border: solid 1px #c7c7c7;text-align: center;">
						全宽
					</div>
					<div @click="selectType(dataItem.bg.setWidth,'px')"
						:style="{backgroundColor: dataItem.bg.setWidth.type == 'px'?'#605bf6':'#fff',color: dataItem.bg.setWidth.type == 'px'?'#fff':'#000'}"
						style="width: 120px;padding: 4px;border: solid 1px #c7c7c7;border-radius: 0px 6px 6px 0px;text-align: center;">
						盒装
					</div>
				</div>
			</div>
		</div>
		<!-- <div  style="font-size: 14px;margin-left: 10px;display: flex;align-items: center;">
			<div>
				页脚高度设置
			</div>
			<div>
				<el-input  onkeyup="this.value=this.value.replace(/\D/g,'')"
					style="width: 259px;margin-top: 10px;margin-left: 10px;" placeholder="请输入内容" v-model="dataItem.footerSetHeight.height" clearable>
					<template slot="append">px</template>
				</el-input>
			</div>
		</div> -->
		<div v-if="dataItem.bg.setWidth.type == 'px'"
			style="margin-left: 10px;display: flex;align-items: center;">
			<div style="font-size: 14px;">盒装宽度设置</div>
			<el-input size="small" @input="ipt(dataItem.bg.setWidth)" @change="changeIpt(dataItem.bg.setWidth)"
				style="width: 259px;margin-top: 10px;margin-left: 10px;" placeholder="请输入内容"
				v-model="dataItem.bg.setWidth.width" clearable>
				<template slot="append">px</template>
			</el-input>
		</div>
		<div style="font-size: 14px;margin-left: 10px;display: flex;align-items: center;margin-top: 10px;">
			<div>
				页脚阴影设置
			</div>
			<div style="margin-left: 10px;">
				<el-color-picker size="medium" v-model="dataItem.topShadow.bgColor"></el-color-picker>
			</div>
			<el-input size="small" onkeyup="this.value=this.value.replace(/\D/g,'')"
				style="width: 194px;margin-left: 10px;" placeholder="y偏移量"
				v-model="dataItem.topShadow.y" clearable>
				<template slot="append">上偏移量</template>
			</el-input>
			<el-input size="small" onkeyup="this.value=this.value.replace(/\D/g,'')"
				style="width: 194px;margin-left: 10px;" placeholder="模糊半径"
				v-model="dataItem.topShadow.r" clearable>
				<template slot="append">模糊半径</template>
			</el-input>
		</div>
		<set-bg :dataItem="dataItem.bg"></set-bg> 
		<set-box-bg v-if="dataItem.bg.setWidth.type == 'px'"  :dataItem="dataItem.box"></set-box-bg>
	</div>
</template>

<script>
	import setBg from './setBg.vue'
	import setBoxBg from './setBoxBg.vue'
	export default {
		components:{
			setBg,
			setBoxBg
		},
		props: {
			dataItem: {
				type: Object,
				default: () => {
					return {}
				}
			},
		},
		data() {
			return {
				type:"percentage",
				width: '1000'
			}
		},
		watch: {
			dataItem: {
				immediate:true,
				deep: true,
				handler: function(newVal, oldVal) {
					console.log('newVal', newVal)
					// if(!newVal.btoShadow) {
					// 	newVal.topShadow = {
					// 	}
					// }
					
				}
			}
		},
		methods: {
			ipt(e) {
				e.width = e.width.replace(/\D/g, '')
				if (e.type == 'px') {
					this.width = e.width
				}
			},
			selectType(e, type) {
				e.type = type
				if (type == 'percentage') {
					e.width = '100'
				}
				if (type == 'px') {
					e.width = this.width
				}
				this.type = type
			},
			changeIpt(e) {
				console.log('changeIpt e',e)
				if (e.type == 'percentage') {
					if (parseInt(e.width) > 100) {
						e.width = '100'
					}
				}
				console.log('e', e)
			}
		}
	}
</script>

<style scoped lang="scss">
	::v-deep .el-input__inner:focus {
		border-color: #242754
	}
</style>